module.exports = __webpack_public_path__ + "img/widgettrust-3.795b1266.png";